export default __webpack_public_path__ + "media/images/progress-indicator-e67d85a8d2d4021514815d0ff4d65173.gif";